console.log('1.0.6')
var data = {
    shop: "party-mania-usa.myshopify.com" 
}

var headers = {
   "Content-Type": "application/json",                                                                                                
   "Access-Control-Origin": "*"
}

fetch("https://admin.cantspy.com/api/disabled/customer", {
    method: "POST",
    headers: headers,
    body:  JSON.stringify(data)
})
.then(function(response){ 
    return response.json(); 
})
.then(function(data){ 
    if( data.status == 1 ) {
        if( data.url_redirect ) {
          window.location.href = data.url_redirect;
        }
    }
});


// *********
// ** Start disable right click on images
// *********
// function nocontext(e) {
//     var clickedTag = (e==null) ? event.srcElement.tagName : e.target.tagName;
//     console.log( clickedTag )
//     if (clickedTag == "IMG") {
//         return false;
//     }
// }
// document.oncontextmenu = nocontext;
// *********
// ** End disable right click on images
// *********

// *********
// ** Start disable right click on images
// *********
// document.addEventListener('contextmenu', function(e) {
//     e.preventDefault();
// });
// *********
// ** Disable right click on web page
// *********

// *********
// ** Start Disable drag & drop
// *********
// document.addEventListener('dragstart', (e) => {
//     e.preventDefault()
// })
// document.addEventListener('drop', (e) => {
//     e.preventDefault()
// })
// *********
// ** Disable Disable drag & drop
// *********

// *********
// ** Start Disable keyboard shortcuts (cut, copy and view-source)
// *********
// document.addEventListener('copy', function (e){
//     e.preventDefault();
//     e.clipboardData.setData("text/plain", "Do not copy this site's content!");
// })
// *********
// ** Disable Disable keyboard shortcuts (cut, copy and view-source)
// *********

// *********
// ** Start Disable text selection
// *********
// window.addEventListener('selectstart', function(e){ e.preventDefault(); });
// *********
// ** Disable Disable text selection
// *********

// *********
// ** Start Prevent showing Download button for HTML 5 video
// *********
// var noDownload = function() {
//     var videoElem = document.getElementsByTagName("VIDEO");
//     for (x in videoElem) {
//   	    if (isNaN(x) == true) {
//             continue;
//         }
//   	    videoElem[x].setAttribute("controlsList", "nodownload");
//     }
// }
// noDownload();
// *********
// ** Disable Prevent showing Download button for HTML 5 video
// *********

// *********
// ** Start Disable the debugger
// *********

// *********
// ** Disable Disable the debugger
// *********

// *********
// ** Start Prevent printing
// *********

// *********
// ** Disable Prevent printing
// *********

// *********
// ** Start Remove Shopify badge & Shopify admin bar
// *********

// *********
// ** Disable Remove Shopify badge & Shopify admin bar
// *********

// *********
// ** Start Hide Google reCaptcha badge 
// *********

// *********
// ** Disable Hide Google reCaptcha badge 
// *********